import { Component, Input } from '@angular/core';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-slider-event',
  templateUrl: './slider-event.component.html',
  styleUrls: ['./slider-event.component.scss']
})
export class SliderEventComponent {
  @Input() data: any;

  public configSliderEvent: SwiperOptions = {
    effect: 'fade',
    parallax: true,
    speed: 800,
    slidesPerView: 1,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-event-pagination',
      clickable: true
    },
  }
}
